import { AiFillGithub } from 'react-icons/ai';


export const Footer = () => {
    return (
      <footer className="flex mb-5 justify-center text-opacity-50 fill-pink-500 items-center">
      <a className='flex flex-row gap-5' href="https://github.com/wird-uk/climb"><h1>Checkout the code on</h1>{<AiFillGithub />}</a>
      </footer>
    )
  }